import { XIcon } from "./Icons";
import styles from "./Header.module.css";

export const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.brand}>
          <span className={styles.brandMark} aria-hidden="true" />
          <span className={styles.brandLabel}>Scriber O</span>
        </div>

        {/* <div className={styles.socialIcons}>
          <a
            href="https://x.com/MindScriber"
            className={styles.icon}
            aria-label="Visit us on X (Twitter)"
          >
            <XIcon />
          </a>
        </div> */}
      </div>
    </header>
  );
};
